module.exports = __webpack_public_path__ + "static/media/medium.249c423e.jpg";